<template>
  <div class="page_container_wrap">
    <div :class="`banner_container`">
      <div class="banner_container_real">
        <div class="banner_container_real_bgc">
          <img src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202307/52f4d043f43242629515d7eed438a0dc.png" alt="背景">
        </div>
        <div class="banner_container_real_content">
          <h3 class="banner_title">教室巡视</h3>
          <p class="banner_sub_title">1、巡视时，如设备正在使用摄像头授课，则无法查看教室内画面</p>
          <p class="banner_sub_title">2、设备被多人巡视时，巡视画面质量可能受损，出现掉帧、花屏现象</p>
          <div class="banner_btn" @click="handleInspectionTourHistory">
            <p class="banner_btn_title">查看巡视历史</p>
            <img class="banner_btn_icon" src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202307/b695f8f391c74945b5efafa7eebd328d.png" alt="眼睛">
          </div>
        </div>
      </div>
    </div>
    <div class="body_container">
      <div class="body_container_header">
        <div class="org_container">
          <p class="org_container_name">{{ schoolSelectName || '- -' }}</p>
          <img class="org_container_icon" src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202307/ddd303c5e801417d820d391216d4e848.png" alt="切换" @click="switchingSchoolDialogFlag = true">
        </div>
        <div class="call_zhihuishu" @click="contactCustomerServiceDialogFlag = true">
          <p class="call_zhihuishu_title">联系智慧树</p>
          <img class="call_zhihuishu_icon" src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202307/f9830ef9675b42d5884c968a480a0b24.png" alt="电话">
        </div>
      </div>
      <div class="body_container_content">
        <div class="body_container_content_org_tree">
          <div class="org_tree_container_radio_group">
            <div :class="['org_tree_container_radio_item', item.active ? 'active' : '', item.disabled ? 'disabled' : '']" :style="item.style" v-for="item in orgTreeContainerRadioList" :key="item.title">
              {{ item.title }}
            </div>
          </div>
          <div class="org_tree_container_body">
            <a-tree
              v-if="buildingTreeData.length > 0"
              blockNode
              checkable
              defaultExpandAll
              :tree-data="buildingTreeData"
              @check="handleBuildingTreeDataItemCheck"
              :checkedKeys="treeCheckedKeys"
              @select="treeSelect"
            >
              <template #title="{ title, key, classroomTotal, inUseClassroomTotal }">
                <div class="tree_title_container">
                  <a-tooltip>
                    <template slot="title">
                      <div>{{ title }}</div>
                    </template>
                    <div class="tree_title_target">{{ title }}</div>
                  </a-tooltip>
                  <!-- <div class="tree_title_sub">
                  (
                  <span>2</span>
                  <span class="gray">/</span>
                  <span class="gray">30</span>
                  )
                  </div> -->
                  <div class="tree_title_sub">
                    <span class="gray">(<span class="use-sum">{{`${inUseClassroomTotal}`}}</span>/{{ `${classroomTotal}` }})</span>
                  </div>
                </div>
              </template>
            </a-tree>
          </div>
        </div>
        <div class="body_container_content_real">
          <transition name="commonpage">
            <router-view />
          </transition>
        </div>
      </div>
    </div>
    <switching-school
      :switchingSchoolDialogFlag="switchingSchoolDialogFlag"
      @handleSwitchingSchoolDialogClose="handleSwitchingSchoolDialogClose"
    />
    <contact-customer-service
      :contactCustomerServiceDialogFlag="contactCustomerServiceDialogFlag"
      @handleContactCustomerServiceDialogClose="handleContactCustomerServiceDialogClose"
    />
  </div>
</template>

<script>
// import lodash from 'lodash'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'ClassroomInspectionTour',
  components: {
    'switching-school': () => import('@/components/switchingSchool'),
    'contact-customer-service': () => import('@/components/contactCustomerService')
  },
  data () {
    return {
      // bannerSlideUp: false,
      // isMainDomScrollBottom: false,
      switchingSchoolDialogFlag: false,
      contactCustomerServiceDialogFlag: false,
      orgTreeContainerRadioList: [
        {
          title: '按建筑',
          active: true,
          disabled: false,
          style: {
            borderRadius: '2px 0px 0px 2px'
          }
        },
        {
          title: '按班级',
          active: false,
          disabled: true,
          style: {
            borderRadius: '0px 2px 2px 0px'
          }
        }
      ],
      buildingTreeData: [],
      buildingAllList: [],
      mainDom: null,
      treeCheckedKeys: []
    }
  },
  computed: {
    ...mapGetters('switchingSchool', ['schoolSelect', 'schoolSelectName'])
  },
  watch: {
    schoolSelect: {
      handler: function (newVal) {
        if (!newVal) return
        this.getBuildingTreeData()
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations('switchingSchool', {
      setBuildingIds: 'setBuildingIds'
    }),
    ...mapMutations('inspectionTour', {
      clearSearchState: 'clearSearchState'
    }),
    treeSelect(s, e) {
      e.node.onExpand()
    },
    handleInspectionTourHistory () {
      this.$router.push({ name: 'InspectionTourHistory' })
    },
    handleSwitchingSchoolDialogClose (isConfirm) {
      this.switchingSchoolDialogFlag = false
      if (isConfirm) {
        this.resetPath()
      }
    },
    handleContactCustomerServiceDialogClose () {
      this.contactCustomerServiceDialogFlag = false
    },
    async getBuildingTreeData () {
      try {
        this.buildingTreeData = []
        const result = await this.$http.getClassroomFilterTree({
          schoolCode: this.schoolSelect
        })
        if (result.code !== 200) return
        this.buildingAllList = []
        this.setBuildingIds([])
        // this.buildingTreeData = this.disposeBuildingTreeData(result.rt.campusList || [])
        this.buildingTreeData = [
          {
            title: '全部',
            key: this.schoolSelect,
            children: this.disposeBuildingTreeData(result.rt.campusList || []),
            classroomTotal: result.rt.classroomSumTotal || 0,
            inUseClassroomTotal: result.rt.inUseClassroomSumTotal || 0
          }
        ]
        this.treeCheckedKeys = this.buildingAllList.map(v => v.key)
        this.setBuildingIds(this.treeCheckedKeys)
      } catch (err) {
        console.log(err)
      }
    },
    disposeBuildingTreeData (buildingTreeData) {
      buildingTreeData.map(item => {
        if (item.buildingInfos && item.buildingInfos.length) {
          item.children = item.buildingInfos
        } else {
          this.buildingAllList.push(item)
        }
        if (item.children && item.children.length) {
          this.disposeBuildingTreeData(item.children)
        }
        item.title = item.campusName || item.buildingName
        item.key = item.campusId || item.buildingId
        item.sort = item.campusSort || item.buildingSort
      })
      return buildingTreeData
    },
    handleBuildingTreeDataItemCheck (checkedKeys, e) {
      // 所有楼栋的集合：
      const buildingIdAllList = this.buildingAllList.map(v => v.key)
      // 当前选择的校区：
      // const campusIds = checkedKeys.filter(item => !buildingIdAllList.includes(item))
      // 当前选择的楼栋：
      const buildingIds = checkedKeys.filter(item => buildingIdAllList.includes(item))
      this.treeCheckedKeys = buildingIds
      this.setBuildingIds(buildingIds)
      this.resetPath()
    },
    resetPath () {
      if (this.$route.name !== 'OnLineInspectionTour') {
        this.$router.push({ name: 'OnLineInspectionTour' })
      }
    }
  },

  mounted () {
    // const self = this
    // self.mainDom = document.querySelector('.ant-layout-content')
    // // 滚动到底分页加载
    // self.mainDom.addEventListener('scroll', lodash.throttle(function(e) {

    //   // if (self.mainDom.scrollHeight <= document.body.scrollHeight + 180) return
    //   // if (self.mainDom.scrollTop >= 1) {
    //   //   self.bannerSlideUp = true
    //   // } else if ( self.mainDom.scrollTop <= 0) {
    //   //   self.bannerSlideUp = false
    //   // }
    // }, 400))


  },
  // destroyed() {
  //   this.mainDom.removeEventListener('scroll', () => {
  //     console.log('mainDom removeEventListener')
  //   })
  // }
  destroyed () {
    this.clearSearchState()
  }
}
</script>

<style lang="scss" scoped>
  .page_container_wrap {
    width: 100%;
    // height: calc(100vh - 96px);
    height: 100%;
    text-align: left;
    // display: flex;
    // flex-direction: column;
    .banner_container {
      width: 100%;
      height: 151px;
      position: relative;
      // transition: height 0.3s linear;
      // &.banner_slideUp{
      //   height: 0;
      // }
      .banner_container_real {
        width: calc(100% + 40px);
        height: 171px;
        position: absolute;
        top: -20px;
        left: -20px;
        display: flex;
        .banner_container_real_bgc {
          width: 282px;
          height: 250px;
          // background-color: #F6F8FA;
          img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
        .banner_container_real_content {
          flex: 1;
          // background-color: #F6F8FA;
          padding-top: 20px;
          padding-left: 72px;
          .banner_title {
            font-size: 20px;
            font-weight: 500;
            color: #1E2228;
            margin-bottom: 15px;
          }
          .banner_sub_title {
            font-size: 14px;
            color: #6F7C91;
            line-height: 20px;
          }
          .banner_btn {
            font-size: 14px;
            margin-top: 15px;
            color: #5F60D3;
            display: inline-block;
            cursor: pointer;
            user-select: none;
            &:hover {
              font-weight: bold;
            }
            &:active {
              font-weight: normal;
            }
            .banner_btn_title {
              float: left;
              line-height: 20px;
            }
            .banner_btn_icon {
              width: 20px;
              height: 20px;
              float: left;
              margin-left: 10px;
              display: block;
            }
          }
        }
      }
    }
    .body_container {
      position: relative;
      // overflow-y: auto;
      height: calc(100% - 151px);
      .body_container_header {
        width: 100%;
        height: 52px;
        background-color: #FFF;
        box-shadow: 0px 1px 1px 0px #EAECED;
        display: flex;
        justify-content: space-between;
        padding: 0 20px 0 16px;
        border-bottom: 1px solid #EAECED;
        .org_container {
          display: flex;
          align-items: center;
          .org_container_name {
            font-size: 14px;
            color: #1E2228;
            margin-right: 8px;
          }
          .org_container_icon {
            width: 16px;
            height: 16px;
            display: block;
            cursor: pointer;
            user-select: none;
          }
        }
        .call_zhihuishu {
          display: flex;
          align-items: center;
          .call_zhihuishu_title {
            font-size: 14px;
            color: #5F60D3;
            margin-right: 11px;
            cursor: pointer;
            user-select: none;
            &:hover {
              font-weight: bold;
            }
            &:active {
              font-weight: normal;
            }
          }
          .call_zhihuishu_icon {
            width: 20px;
            height: 20px;
            display: block;
          }
        }
      }
      .body_container_content {
        width: 100%;
        min-height: calc(100% - 52px);
        // height: auto;
        background-color: #FFF;
        display: flex;
        .body_container_content_org_tree {
          width: 192px;
          height: inherit;

          // padding: 16px;
          border-right: 1px solid #EAECED;
          .org_tree_container_radio_group {
            display: flex;
            padding-top: 16px;
            justify-content: center;
            .org_tree_container_radio_item {
              width: 80px;
              height: 30px;
              display: flex;
              justify-content: center;
              align-items: center;
              user-select: none;
              &.active {
                background: #5F60D3;
                border: 1px solid #5F60D3;
                cursor: pointer;
                color: #FFF;
              }
              &:hover {
                font-weight: bold;
              }
              &.disabled {
                background: #ECEEF3;
                border: 1px solid #D5D7DF;
                cursor: not-allowed;
                color: #AFB1B8;
                &:hover {
                  font-weight: normal;
                }
              }
            }
          }
          .org_tree_container_body {
            overflow-x: hidden;
            .tree_title_container {
              font-size: 13px;
              color: #1E2228;
              display: flex;
              .tree_title_target {
                // max-width: 76px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .tree_title_sub {
                color: #1E2228;
                margin-left: 6px;
                .gray {
                  color: #6F7C91;
                  .use-sum{
                    color:#1E2228;
                  }
                }
              }
            }
            ::v-deep.ant-tree{
              margin-left: -20px;
            }
            ::v-deep.ant-tree-node-content-wrapper:hover,
            ::v-deep.ant-tree-node-content-wrapper.ant-tree-node-selected {
              background-color: #FFF;
            }
            ::v-deep.ant-tree-checkbox-checked .ant-tree-checkbox-inner {
              background-color: #5f60d3;
              border-color: #5f60d3;
            }
            ::v-deep.ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner::after {
              background-color: #5f60d3;
            }
          }
        }
        .body_container_content_real {
          flex: 1;
          width: calc(100% - 192px);
        }
      }
    }
  }
</style>